import { atom } from "jotai";

import type { NavItem } from "@/routes/menuConfig";
import type { SessionUser } from "@/types/auth";
import { clearToken } from "@/utils";

/** bootstrap 生命周期状态 */
export type BootstrapStatus = "idle" | "loading" | "ready" | "guest";

/** 应用 bootstrap 状态 */
export interface BootstrapState {
  /** 当前状态 */
  status: BootstrapStatus;
  /** 会话代数：丢弃过期异步写入 */
  session: number;
}

/** 当前登录用户（会话级精简字段） */
export const currentUserAtom = atom<SessionUser | null>(null);

/** 当前用户权限码列表 */
export const permissionsAtom = atom<string[]>([]);

/** 当前用户侧边栏菜单树（接口下发） */
export const menusAtom = atom<NavItem[]>([]);

/** 应用 bootstrap 状态（idle → loading → ready/guest） */
export const bootstrapAtom = atom<BootstrapState>({ status: "idle", session: 0 });

/** 鉴权 bootstrap 是否已完成（ready 或 guest 均可渲染路由） */
export const authReadyAtom = atom((get) => {
  const { status } = get(bootstrapAtom);
  return status === "ready" || status === "guest";
});

/**
 * 重置会话为访客态：清 token、清鉴权数据、递增 session
 * 供手动退出、401 拦截器等非 React 环境调用
 */
export const resetSessionAtom = atom(null, (get, set) => {
  const nextSession = get(bootstrapAtom).session + 1;
  clearToken();
  set(currentUserAtom, null);
  set(menusAtom, []);
  set(permissionsAtom, []);
  set(bootstrapAtom, { status: "guest", session: nextSession });
});
